import {GenericApi} from "./generic-api";
import {API} from "../api-endpoints";

/**
 * Service for Accommodation Application (public apply form) related API calls.
 * Base URL: /apply
 */
export class ApplicationService extends GenericApi {
    private static _instance: ApplicationService;

    public static get instance(): ApplicationService {
        if (!this._instance) this._instance = new ApplicationService();
        return this._instance;
    }

    private constructor() { super(API.apply); }

    async submit(data: object): Promise<any> {
        return this.postData<any>(``, data);
    }

    /** Returns true if the student number exists in the system. */
    async checkExists(studentNumber: string): Promise<boolean> {
        const response = await fetch(`${this.baseUrl}/exists?studentNumber=${encodeURIComponent(studentNumber)}`);
        return response.ok;
    }

    /** Returns available room types for a building, counted against the chosen application year. */
    async checkAvailability(buildingName: string, year?: string): Promise<any[]> {
        const yearParam = year ? `&year=${encodeURIComponent(year)}` : '';
        return this.fetchData<any[]>(`availability?building=${encodeURIComponent(buildingName)}${yearParam}`);
    }
}

